import type { Tone } from '@/papermill/stages';

import styles from './JobStatusBadge.module.css';

const GLYPHS: Record<Tone, string> = {
  queued: '•',
  running: '',
  success: '✓',
  warning: '!',
  danger: '✕',
};

export function JobStatusBadge({ label, tone }: { label: string; tone: Tone }) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {tone === 'running' ? (
        <span className={styles.pulse} aria-hidden="true" />
      ) : (
        <span aria-hidden="true">{GLYPHS[tone]}</span>
      )}
      {label}
    </span>
  );
}
